<template>
    <div class="m-1">
        <CRow>
            <CCol col="3">
                <CButton
                    v-show="!isLoadingDocumentos"
                    size="sm"
                    class="btn-class mb-1"
                    @click="getDocumentosMail">
                    <CIcon name="cil-check-circle" /> Recargar Información
                </CButton>
            </CCol>
        </CRow>
        
        <CargandoInfo :mostrarCarga="isLoadingDocumentos" :mensajeInfo="'Obteniendo Información'" />
        
        <CRow class="mt-1" v-sjow="!isLoadingDocumentos">
            <CCol sm="12" md="12" lg="12" v-if="documentos.length<=0"><center>No hay documentos encontrados</center></CCol>
            <CCol v-else sm="12" md="12" lg="12" 
                v-bind:key="documento.idDocumento" 
                v-for="(documento, i) in documentos">
                <!--{{ documento }}-->
                    <!--<DocumentoInfo :documento="documento" />-->
                    <CCard accent-color="secondary" class="mt-1 mb-1">
                        <CCardHeader>
                            <div class="card-header-actions">
                                <CLink class="card-header-action btn-minimize float-left" @click="documento.acciones.mostrarDoc = !documento.acciones.mostrarDoc">
                                    <CIcon v-show="documento.acciones.mostrarDoc" :content="$options.freeSet.cilChevronTop" />
                                    <CIcon v-show="!documento.acciones.mostrarDoc" :content="$options.freeSet.cilChevronBottom" />
                                </CLink>
                            </div>
                            <CRow>
                                <CCol col="12">
                                    <div class="text-center mb-3" style="font-size: 15px;">
                                        <span class="font-weight-bold">N° Documento: </span> {{ documento.codigoDocumento }}
                                        <span>(
                                            <a 
                                                v-if="documento.idArchivoDrive != null"
                                                :href="documento.urlDescarga" 
                                                target="_blank" 
                                                style="text-decoration: none; color:#0b7689;" 
                                                content="Descargar Documento"
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"
                                            >
                                                <CIcon :content="$options.freeSet.cilCloudDownload" />                               
                                            </a>
                                            <a
                                                v-else
                                                size="sm" variant="ghost"
                                                content="Sin Archivo"
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }"
                                                >
                                                <CIcon
                                                    :content="$options.freeSet.cilMeh"
                                                />
                                            </a> )
                                        </span>
                                    </div>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol>
                                    <div><span class="font-weight-bold">Tipo: </span> {{ documento.tipoDocumento == 1 ? 'Nota Venta' : 'Otro' }}</div>
                                    <div>
                                        <span class="font-weight-bold">Nula: </span>
                                        <CIcon style="color:red" name="cil-check-circle" v-show="documento.nula"/>
                                        <CIcon style="color:green" name="cil-x-circle" v-show="!documento.nula" />
                                    </div>
                                    <div v-if="documento.nula"><span class="font-weight-bold">Fecha Rechazo: </span> {{ documento.fechaRechazo }}</div>
                                    
                                    <div><span class="font-weight-bold">Emisor: </span> {{ documento.emisor != null ? documento.emisor.nombreEmisor : 'Sin Emisor' }}</div>
                                    <div><span class="font-weight-bold">Fecha Documento: </span> {{ $utils.formatearFecha(documento.fechaDocumento) }}</div>
                                    <div><span class="font-weight-bold">Fecha Recepción: </span> {{ $utils.formatearFecha(documento.fechaRecepcionDocumento) }}</div>
                                </CCol>
                                <CCol>
                                    <div><span class="font-weight-bold">Rut Documento: </span>{{ $utils.formatearRut(documento.rutDocumento) }}</div>
                                    <div><span class="font-weight-bold">Razon Social Documento: </span>{{ documento.nombreEmpresa}}</div>
                                    
                                    <div v-if="documento.datosFacturacion"><span class="font-weight-bold">Rut Facturación: </span>{{ $utils.formatearRut(documento.infoDatosFacturacion.rutFacturacion) }}</div>
                                    <div v-if="documento.datosFacturacion"><span class="font-weight-bold">RS Facturación: </span>{{ documento.infoDatosFacturacion.razonSocialFacturacion }} </div>
                                </CCol>
                                <CCol>
                                    <div><span class="font-weight-bold">Neto Documento: </span>{{ $utils.validarNegativos(documento.valoresDocumento.valorNeto, 'currency') }}</div>
                                    <div><span class="font-weight-bold">IVA Documento: </span>{{ $utils.validarNegativos(documento.valoresDocumento.valorIva, 'currency') }}</div>
                                    <div><span class="font-weight-bold">Total Documento: </span>{{ $utils.validarNegativos(documento.valoresDocumento.valorTotal, 'currency') }}</div>
                                </CCol>

                            </CRow>
                            <!--<CRow>
                                <CCol col="12">
                                    <div class="text-center mb-3" style="font-size: 15px;">
                                        <span class="font-weight-bold">N° Documento: </span> {{ documento.codigoDocumento }}
                                        <span>(
                                            <a 
                                                v-if="documento.hayDocumento"
                                                :href="documento.urlDocumento" 
                                                target="_blank" 
                                                style="text-decoration: none; color:#0b7689;" 
                                                content="Descargar Documento"
                                                v-tippy="{ 
                                                    placement: 'top',
                                                    arrow: true, 
                                                    arrowType: 'round', 
                                                    animation:'fade',
                                                    theme: 'google',
                                                    followCursor : true,
                                                }"
                                            >
                                                <CIcon :content="$options.freeSet.cilCloudDownload" />                               
                                            </a>
                                            <a
                                                v-else
                                                size="sm" variant="ghost"
                                                content="Sin Archivo"
                                                    v-tippy="{ 
                                                        placement: 'top',
                                                        arrow: true, 
                                                        arrowType: 'round', 
                                                        animation:'fade',
                                                        theme: 'google',
                                                        followCursor : true,
                                                    }"
                                                >
                                                <CIcon
                                                    :content="$options.freeSet.cilMeh"
                                                />
                                            </a> )
                                        </span>
                                    </div>
                                
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol>
                                    
                                    <div><span class="font-weight-bold">Tipo: </span> {{ documento.tipoDocumento }}</div>
                                    
                                    <div>
                                        <span class="font-weight-bold">Nula: </span>
                                        <CIcon style="color:red" name="cil-check-circle" v-show="documento.nula"/>
                                        <CIcon style="color:green" name="cil-x-circle" v-show="!documento.nula" />
                                    </div>
                                    <div v-if="documento.hayDocumento && documento.nula"><span class="font-weight-bold">Fecha Rechazo: </span> {{ documento.fechaRechazo }}</div>
                                    
                                    <div><span class="font-weight-bold">Emisor: </span> {{ documento.emisor }}</div>
                                    <div v-if="documento.hayDocumento"><span class="font-weight-bold">Fecha Documento: </span> {{ $utils.formatearFecha(documento.fechaDocumento) }}</div>
                                    <div v-if="documento.hayDocumento"><span class="font-weight-bold">Fecha Recepción: </span> {{ $utils.formatearFecha(documento.fechaRecepcionDocumento) }}</div>
                                    
                                                    
                                </CCol>
                                <CCol>
                                    <div v-if="documento.hayDocumento"><span class="font-weight-bold">Rut Documento: </span>{{ $utils.formatearRut(documento.rutDocumento) }}</div>
                                    <div v-if="documento.hayDocumento"><span class="font-weight-bold">Razon Social Documento: </span>{{ documento.razonSocialDocumento}}</div>
                                    
                                    <div v-if="documento.hayDocumento && documento.datosFacturacion"><span class="font-weight-bold">Rut Facturación: </span>{{ $utils.formatearRut(documento.infoDatosFacturacion.rutFacturacion) }}</div>
                                    <div v-if="documento.hayDocumento && documento.datosFacturacion"><span class="font-weight-bold">RS Facturación: </span>{{ documento.infoDatosFacturacion.razonSocialFacturacion }} </div>
                                </CCol>
                                <CCol>
                                    <div v-if="documento.hayDocumento"><span class="font-weight-bold">Neto Documento: </span>{{ $utils.validarNegativos(documento.valoresDocumento.valorNeto, 'currency') }}</div>
                                    <div v-if="documento.hayDocumento"><span class="font-weight-bold">IVA Documento: </span>{{ $utils.validarNegativos(documento.valoresDocumento.valorIva, 'currency') }}</div>
                                    <div v-if="documento.hayDocumento"><span class="font-weight-bold">Total Documento: </span>{{ $utils.validarNegativos(documento.valoresDocumento.valorTotal, 'currency') }}</div>
                                </CCol>
                            </CRow>
                            -->
                        </CCardHeader>
                    </CCard>
            </CCol>
        </CRow>
    </div>
</template>
    
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    
    import cons from '@/const'
    import Multiselect from 'vue-multiselect'
    import axios from "axios"
    import { format, formatDistance, formatRelative, subDays } from "date-fns";
    import es from "date-fns/locale/es";
    
    import { freeSet } from "@coreui/icons";
    
    
    export default {
        name: 'DocumentosMail',
        freeSet,
        props: {
            documento: Object
        },
        components: {
            Multiselect,
        },
        data () {
            return {
                baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,

                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,
                
                isLoadingDocumentos: false,
                documentos: [],

            }
        },
        created: function(){},
        beforeMount() {
            this.getDocumentosMail()
            

        },
        methods: {

            getDocumentosMail: function(){
                this.isLoadingDocumentos = true
                let url = this.baseUrl + "/get_documentos_registrados";
                axios({
                    method: "POST",
                    url: url,
                    data: {
                        //"filtroCliente": this.filtrosClientesVappEdig,
                        //"filtroTexto": this.filtroGeneralCliente,
                        "paginacion": {
                            "paginacion": false,
                            "actual": this.page,
                            "tamanioPagina": 10
                        }
                    },
                    headers: {
                        Authorization: this.tokenLogin,
                    },
                })
                    .then((result) => {
                        console.log("result", result.data)
                        this.documentos = result.data.documentos
                        this.isLoadingDocumentos = false
                    },
                    (error) => {
                        this.isLoadingDocumentos = false
                    }
                    )
                    .finally(() => {
                        this.isLoadingDocumentos = false
                    });
                
            },
            

        }
        
    }
</script>